import React from 'react';
import { profileData, credentials, expertise } from '../mock';
import { CheckCircle } from 'lucide-react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-header">
          <span className="section-label">About</span>
          <h2 className="section-title">Strategic Leadership in Global Affairs</h2>
        </div>

        <div className="about-content">
          <div className="about-images-wrapper">
            <div className="about-image-container">
              <img
                src={profileData.profileImage}
                alt={profileData.name}
                className="about-image"
              />
              <div className="about-image-accent"></div>
            </div>
            <div className="about-image-container about-image-secondary">
              <img
                src={profileData.profileImage2}
                alt={profileData.name}
                className="about-image"
              />
              <div className="about-image-accent"></div>
            </div>
          </div>

          <div className="about-text">
            <p className="about-bio">{profileData.bio}</p>

            <div className="expertise-section">
              <h3 className="expertise-title">Areas of Expertise</h3>
              <div className="expertise-grid">
                {expertise.map((item, index) => (
                  <div key={index} className="expertise-item">
                    <CheckCircle size={18} className="check-icon" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="credentials-section">
              {credentials.map((cred, index) => (
                <div key={index} className="credential-block">
                  <h4 className="credential-title">{cred.type}</h4>
                  <ul className="credential-list">
                    {cred.items.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
